import axios from 'axios';
import { GET_NOTIFICATIONS, MARK_NOTIFICATION_READ, MARK_ALL_NOTIFICATIONS_READ, ADD_NOTIFICATION } from './types';
import { tokenConfig } from './authActions';

export const getNotifications = () => async (dispatch, getState) => {
  try {
    const res = await axios.get('/api/notifications', tokenConfig(getState));
    dispatch({ type: GET_NOTIFICATIONS, payload: res.data });
  } catch (err) {
    // silent fail
  }
};

export const markRead = (id) => async (dispatch, getState) => {
  try {
    const res = await axios.patch(`/api/notifications/${id}/read`, {}, tokenConfig(getState));
    dispatch({ type: MARK_NOTIFICATION_READ, payload: res.data });
  } catch (err) {
    // silent fail
  }
};

export const markAllRead = () => async (dispatch, getState) => {
  try {
    await axios.patch('/api/notifications/read-all', {}, tokenConfig(getState));
    dispatch({ type: MARK_ALL_NOTIFICATIONS_READ });
  } catch (err) {
    // silent fail
  }
};

export const addNotification = (notification) => ({
  type: ADD_NOTIFICATION,
  payload: notification
});
